<div class="backDrop" *ngIf="showDialog">
	<div class="modal-dialog modal-l">
		<div class="modal-content">
			<div>
				<!-- Modal Header -->
				<div class="modal-header ">
					<h4 class="modal-title">Edit: Integration title</h4>
				</div>

				<!-- Modal body -->
				<div class="modal-body">
					<!--inhoud-->
					<dx-text-box [value]="currentTitle"></dx-text-box>
				</div>

				<!-- Modal footer -->
				<div class="modal-footer">
					<button type="button" class="btn btn-success" (click)="save()">
						Save
					</button>
					<button type="button" class="btn btn-primary" (click)="cancel()">
						Cancel
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
